// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__1vwt6","card__img":"index_card__img__2uxIL","card__number":"index_card__number__1ly2z","card__content":"index_card__content__464hE"};